import React, { FC } from 'react';
import ReplayIcon from '@material-ui/icons/Replay';
import { Alert } from '@material-ui/lab';

import { EditButton } from '..';
import Confirmation from '../Confirmation';
import { useClearEmail } from '~/hooks/apiIdentity';
import { useApiIdentityTranslate } from '.';

interface Props {
  identityId: string | undefined;
  className?: string;
  disabled?: boolean;
}

const ClearEmailAction: FC<Props> = (props) => {
  const { className, identityId, disabled } = props;
  const t = useApiIdentityTranslate();

  const clearEmailMutation = useClearEmail();
  const handleClear = () => {
    if (identityId) {
      return clearEmailMutation.mutateAsync(identityId);
    }
  };

  return (
    <Confirmation
      onConfirm={handleClear}
      confirmButtonProps={{ loading: clearEmailMutation.isLoading }}
      confirmationSettings={{
        variant: 'modal',
        modal: { content: <Alert severity='warning'>{t('clearEmailWarning')}</Alert> },
      }}
    >
      <EditButton
        className={className}
        label={t('clearEmail')}
        icon={<ReplayIcon />}
        disabled={disabled}
        red
      />
    </Confirmation>
  );
};

export default ClearEmailAction;
